var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 25.93 26.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;}.cls-1{clip-rule:evenodd;}.cls-3{clip-path:url(#clip-path);}.cls-4{fill:#a7b9c5;}.cls-5{clip-path:url(#clip-path-2);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.05,3.66,9.31.13,9.12,0a.91.91,0,0,0-.23,0H1.18C.53,0,0,.4,0,.88V13.25c0,.49.53.88,1.18.88H13c.66,0,1.19-.39,1.19-.88V4a.33.33,0,0,0-.05-.16A.44.44,0,0,0,14.05,3.66ZM9.48,1.51l2.72,2H9.48ZM8.29.88V3.53c0,.49.54.89,1.19.89H13V7.9L11.1,6.33a.71.71,0,0,0-.44-.15.7.7,0,0,0-.43.15L7.34,8.67,5.8,7.23a.73.73,0,0,0-.7-.12l0,0L5,7.16l0,0,0,0L1.18,10.66V.88Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.75,4.54a1,1,0,0,1,1,1L15.39,15a1,1,0,0,1-1,1L3.43,15.58l.06-1.78.51,0L4,15.1l10.42.36a.51.51,0,0,0,.51-.42V15l.33-9.42a.52.52,0,0,0-.43-.51h-.06L14,5l0-.5Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    width: 24.22,
    height: 24.13
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: -1.12,
    y: -0.88,
    width: 21.43,
    height: 21.93,
    transform: "translate(4.18 24.32) rotate(-88)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon3);
export default __webpack_public_path__ + "static/media/chat-icon3.7e807b24d88ee0002b07820015f184e4.svg";
export { ForwardRef as ReactComponent };